<app-drop-down-universal-sqp [listaDesplegable]="estados"
                             [tituloDropDown]="'Estados'"
                             (seleccionItemSingleOut)="actualizaFiltroEstado($event)"
                             [modo]="'single'"
                             [selectedBackgroundColor]="'var(--sqp-yellow1)'"
                             [optionHoverBackgroundColor]="'var(--sqp-yellow2)'"
                             [mostrarTooltipTituloLista]="true"
                             [mostrarIdEnLabel]="false"
                             [permitirQuitarFiltro]="false"
                             [mostrarBuscador]="false"
                             [anchuraDesplegable]="200"
                             ></app-drop-down-universal-sqp>

